"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _range = _interopRequireDefault(require("lodash/range"));

var _addDebouncedEventListener = _interopRequireDefault(require("./../_utils/add-debounced-event-listener"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(_ref) {
  var slideMaxHeight = _ref.slideMaxHeight,
      spacingInset = _ref.spacingInset,
      animate = _ref.animate,
      motionDuration = _ref.motionDuration,
      motionFunction = _ref.motionFunction,
      width = _ref.width;
  return (0, _emotion.css)({
    boxSizing: "border-box",
    height: slideMaxHeight ? slideMaxHeight + spacingInset * 2 : undefined,
    width: width,
    // Display block to make sure we fill all available width by default. This
    // will help avoid zero width carousels when using a container that's inline
    // by default (the children are absolutely positioned so they won't
    // contribute to the container's width).
    display: "block",
    position: "relative",
    overflow: "hidden",
    transition: animate ? "height ".concat(motionDuration, "ms ").concat(motionFunction) : undefined
  });
};

var slideStyles = function slideStyles(_ref2) {
  var _css;

  var slidesInView = _ref2.slidesInView,
      spacingHorizontal = _ref2.spacingHorizontal,
      slideWidthPercentage = _ref2.slideWidthPercentage,
      spacingInset = _ref2.spacingInset,
      index = _ref2.index,
      slideIndex = _ref2.slideIndex,
      animate = _ref2.animate,
      motionDuration = _ref2.motionDuration,
      motionFunction = _ref2.motionFunction;
  var offset = index - slideIndex; // Calculate the number of pixels we need to subtract from each slide in order
  // to fit them all in the carousel along with the requested horizontal
  // spacing. Round up to ensure that we don't clip subpixels off the last
  // slide.

  var spacingHorizontalWidthReduction = Math.ceil(spacingHorizontal * (slidesInView - 1) / slidesInView); // Positions the slide based on its offset

  var slidePosition = "".concat(offset * 100, "%");
  var slidePositionRtl = "".concat(offset * -100 + (slidesInView - 1) * 100, "%"); // Nudges based on the horizontal space between slides

  var spacingNudge = "".concat(spacingHorizontal * offset, "px");
  var spacingNudgeRtl = "".concat(spacingHorizontal * (offset - (slidesInView - 1)) * -1, "px"); // Nudges based on the percentage width of each slide

  var percentageWidthNudge = slideWidthPercentage ? "".concat((1 - slideWidthPercentage * slidesInView) * 100 / 2 * (1 / slideWidthPercentage), "%") : "0px";
  return (0, _emotion.css)((_css = {
    boxSizing: "border-box",
    position: "absolute",
    top: spacingInset,
    left: spacingInset,
    width: slideWidthPercentage ? "calc((".concat(slideWidthPercentage * 100, "% - ").concat(spacingInset * 2, "px) - ").concat(spacingHorizontalWidthReduction, "px)") : "calc(((100% - ".concat(spacingInset * 2, "px) / ").concat(slidesInView, ") - ").concat(spacingHorizontalWidthReduction, "px)"),
    transform: "translateX(".concat(slidePosition, ") translateX(").concat(spacingNudge, ") translateX(").concat(percentageWidthNudge, ")")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    transform: " translateX(".concat(slidePositionRtl, ") translateX(").concat(spacingNudgeRtl, ") translateX(").concat(percentageWidthNudge, ")")
  }), (0, _defineProperty2["default"])(_css, "transition", animate ? "transform ".concat(motionDuration, "ms ").concat(motionFunction) : undefined), _css));
};
/**
 * This component handles the display and animation of content in carousel
 * slides. It uses a render prop for slides, which allows it to lazily render
 * them only when necessary for smoother animation and infinite lists.
 */


var CarouselController = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CarouselController, _React$Component);

  var _super = _createSuper(CarouselController);

  function CarouselController() {
    var _this;

    (0, _classCallCheck2["default"])(this, CarouselController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "postAnimationTimeout", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "canAnimate", function () {
      return Boolean(_this.props.motionDuration && _this.props.motionFunction);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      // Track the slide index that we'll render separately from the user-provided
      // slide index. This allows us to intelligently pre-render slides when we're
      // not animating, and wait to add new slides or remove old slides until
      // animations have finished.
      renderIndex: _this.props.slideIndex,
      canAnimate: _this.canAnimate(),
      slideHeights: {}
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateSlideHeight", function (index) {
      return function (node) {
        /* eslint-disable-next-line react/no-find-dom-node */
        var domNode = _reactDom["default"].findDOMNode(node);

        if (domNode && domNode.offsetHeight && _this.state.slideHeights[index] === undefined) {
          // NOTE: offsetHeight height is used here (as opposed to
          // getBoundingClientRect) so that any css transforms (e.g. scale) are
          // ignored and the height used by the carousel is the actual height the
          // slide takes up in the layout.
          _this.setState(function (state) {
            return {
              slideHeights: _objectSpread(_objectSpread({}, state.slideHeights), {}, (0, _defineProperty2["default"])({}, index, domNode.offsetHeight))
            };
          });
        }
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(CarouselController, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Clear all cached slide heights when the window is resized since the new
      // layout may cause the slide heights to change.
      this.removeWindowResizeListener = (0, _addDebouncedEventListener["default"])(window, "resize", function () {
        return _this2.setState({
          slideHeights: {}
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.postAnimationTimeout);
      this.removeWindowResizeListener();
    } // Set the height for a single slide

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      // Did the user change the index of the current slide?
      var indexChanged = this.props.slideIndex !== prevProps.slideIndex; // Is the slide index that we're rendering falling too far behind the slide
      // index provided by the user? This can happen if the user is advancing
      // slides faster than we can animate

      var renderIndexBehind = indexChanged && this.state.renderIndex !== prevProps.slideIndex; // Did a motion prop change?

      var motionChanged = this.props.motionDuration !== prevProps.motionDuration || this.props.motionFunction !== prevProps.motionFunction; // If the user is navigating too fast for us to keep up with animation then
      // turn animation off.

      if (renderIndexBehind && this.state.animate) {
        this.setState({
          canAnimate: false
        });
      } else if (motionChanged) {
        // If the user changed a motion prop then re-evaluate our animatability
        this.setState({
          canAnimate: this.canAnimate()
        });
      } // Once the current animation is complete then add/remove slides behind the
      // scenes and make sure animation is turned back on if it was turned off
      // (see above)


      if (indexChanged) {
        clearTimeout(this.postAnimationTimeout);
        this.postAnimationTimeout = setTimeout(function () {
          _this3.setState({
            renderIndex: _this3.props.slideIndex,
            canAnimate: _this3.canAnimate()
          }, _this3.props.onTransitionEnd);
        }, // Wait until 100ms after the animation has completed to ensure things
        // have settled down before rendering new slides behind-the-scenes.
        this.props.motionDuration + 100);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var props = this.props;
      var state = this.state; // Calculate the range of indices that will be in view. When the slides are
      // a percentage width of the carousel (i.e. the next/prev are "peeking"),
      // render yet another two slides so they'll be ready to enter the scene.

      var visibleIndices = (0, _range["default"])(props.slideIndex - (props.slideWidthPercentage ? 1 : 0), props.slideIndex + props.slidesInView + (props.slideWidthPercentage ? 1 : 0)); // Keep track of which slides are peeking so they are correctly set to aria-hidden

      var peekIndices = props.slideWidthPercentage ? [visibleIndices[0], visibleIndices[visibleIndices.length - 1]] : []; // Animate if we can according to the current state *and* if the render
      // index is proximate to the slide index. If the render index is far away
      // from the slide index we want to skip animation to avoid animating across
      // unrendered slides.

      var animate = state.canAnimate && Math.abs(state.renderIndex - props.slideIndex) <= 1; // If we've got animation turned on then intelligently render slides behind
      // the scenes for the smoothest animation, otherwise just render the visible
      // slides. In addition, when the slides are a percentage width of the carousel
      // (i.e. the next/prev are "peeking"), render yet another two slides so they'll
      // be ready to enter the scene.

      var renderIndices = animate ? (0, _range["default"])(state.renderIndex - (props.slideWidthPercentage ? 2 : 1), state.renderIndex + props.slidesInView + (props.slideWidthPercentage ? 2 : 1)) : visibleIndices; // Render one slide before the first visible slide, all the visible slides,
      // and one slide after the last visible slide. This will allow slides just
      // out of view to animate smoothly into view when the slideIndex is changed.

      var slides = renderIndices.map(function (index) {
        return props.renderSlide({
          index: index,
          props: {
            key: index,
            ref: _this4.updateSlideHeight(index),
            // Hide slides from screen readers if they are not visible
            // or only partially visible.
            "aria-hidden": visibleIndices.indexOf(index) === -1 || peekIndices.indexOf(index) !== -1 ? true : undefined,
            className: slideStyles({
              slidesInView: props.slidesInView,
              slideWidthPercentage: props.slideWidthPercentage,
              spacingHorizontal: props.spacingHorizontal,
              spacingInset: props.spacingInset,
              slideIndex: props.slideIndex,
              motionFunction: props.motionFunction,
              motionDuration: props.motionDuration,
              animate: animate,
              index: index
            })
          }
        });
      }); // Render at the max height of any of the visible slides

      var slideMaxHeight = visibleIndices.reduce(function (result, index) {
        return state.slideHeights[index] > result ? state.slideHeights[index] : result;
      }, 0) || undefined;
      return props.renderContainer({
        props: {
          className: styles({
            spacingInset: props.spacingInset,
            motionFunction: props.motionFunction,
            motionDuration: props.motionDuration,
            width: props.width,
            animate: animate,
            slideMaxHeight: slideMaxHeight
          }),
          children: slides
        }
      });
    }
  }]);
  return CarouselController;
}(_react["default"].Component);

(0, _defineProperty2["default"])(CarouselController, "defaultProps", {
  slidesInView: 1,
  spacingHorizontal: 0,
  spacingInset: 0,
  width: "100%"
});
CarouselController.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The function used to render the carousel's container element. The only
   * argument passed to this function is an object with a "props" field. These
   * props should be passed through to the element.
   */
  renderContainer: _propTypes["default"].func.isRequired,

  /**
   * The function used to render a slide element in the carousel. The only
   * argument passed to this function is an object with a "props" field and an
   * "index" field. The props should be passed through to the slide element.
   * The index can be used to determine what the contents of the slide should
   * be.
   */
  renderSlide: _propTypes["default"].func.isRequired,

  /**
   * The index of the current slide.
   */
  slideIndex: _propTypes["default"].number.isRequired,

  /**
   * The duration it should take to animate from one slide to the next in
   * milliseconds.
   */
  motionDuration: _propTypes["default"].number,

  /**
   * The animation function to use when animating from one slide to the next.
   */
  motionFunction: _propTypes["default"].string,

  /**
   * The percentage width each slide takes up relative to the carousel. Use this to
   * create a "peek" of prev/next slides. Use float between 0 ~ 1 e.g. 0.4 for 40%.
   */
  slideWidthPercentage: _propTypes["default"].number,

  /**
   * The number of slides to show at a time.
   */
  slidesInView: _propTypes["default"].number,

  /**
   * The horizontal "gutter" spacing between each slide.
   */
  spacingHorizontal: _propTypes["default"].number,

  /**
   * The inset "padding" spacing for each slide.
   */
  spacingInset: _propTypes["default"].number,

  /**
   * The width of the carousel. Defaults to "100%" so that it fills its
   * parent element.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * A callback to run any time the carousel has finished transitioning to new
   * slide(s).
   */
  onTransitionEnd: _propTypes["default"].func
} : {};
var _default = CarouselController;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/_carousel-controller/carousel-controller.js
// module id = 886
// module chunks = 0